import { Col, Row } from "antd";
import { useFormik } from "formik";
import { get, isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { MdOutlineFace, MdOutlineFace3 } from "react-icons/md";
import { NAME_SPACES } from "shared/locales/constants";
import { CONTACT_POINT_SYSTEM, GENDER } from "utils/constants";
import {
  bindInputProps,
  bindWebTextFieldInputProps,
} from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import validation from "./validation";

function View({ contact, onNext, onBack, locked }) {
  const { t } = useTranslation();
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      ...contact,
      user: {
        ...get(contact, "user", {}),
        gender: get(contact, "user.gender") || null,
      },
    },
    onSubmit: onNext,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });
  return (
    <Layout>
      <Header
        title="Comment vous contacter afin de vous envoyer <b>votre devis</b> ?"
        highlight="Comment vous contacter"
        subtitle="Informations de l’adhérent"
        onBack={onBack}
      />

      <Row justify="center">
        <Col xs={24} md={18}>
          <div className="grid--1">
            <div className="grid--2">
              <Input
                label={"Civilité"}
                size="full"
                row
                type="radio"
                values={[
                  {
                    icon: <MdOutlineFace size={20} />,
                    value: GENDER.MALE,
                    label: "Monsieur",
                  },
                  {
                    icon: <MdOutlineFace3 size={20} />,
                    value: GENDER.FEMALE,
                    label: "Madame",
                  },
                ]}
                {...bindInputProps({
                  name: "user.gender",
                  values,
                  ...formProps,
                })}
                onChange={(value) => setFieldValue("user.gender", value)}
              />
            </div>
            <div className="grid--2">
              <Input
                placeholder={"ex : Doe"}
                label={"Nom"}
                {...bindWebTextFieldInputProps({
                  name: "user.lastname",
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                disabled={locked}
              />
              <Input
                placeholder={"ex : John"}
                label={"Prénom"}
                {...bindWebTextFieldInputProps({
                  name: "user.firstname",
                  values,
                  setFieldValue,
                  ...formProps,
                })}
                disabled={locked}
              />
            </div>

            <div className="grid--2">
              <Input
                placeholder={"ex : email@email.com"}
                label={"Email"}
                {...bindInputProps({
                  name: `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                  values,
                  ...formProps,
                })}
                disabled={locked}
                onChange={({ target: { value } }) => {
                  setFieldValue(
                    `telecoms.${CONTACT_POINT_SYSTEM.EMAIL}.value`,
                    value,
                  );
                }}
              />
              <Input
                placeholder={"ex : 0610203040"}
                label={"N° de téléphone"}
                trim
                {...bindInputProps({
                  name: `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                  values,
                  ...formProps,
                })}
                disabled={locked}
                onChange={({ target: { value } }) => {
                  setFieldValue(
                    `telecoms.${CONTACT_POINT_SYSTEM.PHONE}.value`,
                    value.replace(/\s+/g, ""),
                  );
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      <ActionButtons
        onNext={handleSubmit}
        disabled={!get(values, "user.firstname") || !isEmpty(formProps.errors)}
        onBack={onBack}
        buttonText="Continuer"
      />
    </Layout>
  );
}

export default View;
